export default __webpack_public_path__ + "static/media/placeholder_dummy2016-restaurant01-mobile-de.ddd3dcb9.png";